/**
 * La nota del asistente con opciones (D49 de `conversaciones-agente-ia`).
 *
 * Al asistente le falta una decisión que cambia el precio o el producto —el color de las tablas, la
 * marca—: la pregunta va en la nota y las opciones como radio. El operador elige con un clic, la
 * elección queda en la nota (una sola vez) y sale además como nota suya arrobando al asistente, que
 * es la que lo despierta.
 */
import type { NoteView, TimelineRow } from "@/services/conversations.api";

/**
 * La fila suelta del timeline de una nota, con todo lo que el render necesita: una general, o una de
 * un mensaje que todavía no está en pantalla (D67), que lleva su `messageId` en `noteMessageId`.
 */
export function filaDeNota(note: NoteView): TimelineRow {
  return {
    kind: "note",
    id: note.noteId,
    occurredAt: note.createdAt ?? new Date().toISOString(),
    payload: {
      noteId: note.noteId,
      noteMessageId: note.messageId ?? null,
      authorUserId: note.authorUserId,
      authorName: note.authorName,
      content: note.content,
      mentions: note.mentions,
      choices: note.choices ?? null,
      replyTo: note.replyTo ?? null,
      task: note.task ?? null,
    },
  };
}

/**
 * `note:updated`: reemplaza la nota que ya está en pantalla —general o anidada— sin moverla de lugar.
 * Si no está (todavía no se cargó esa página), no agrega nada: la va a traer el timeline.
 */
export function actualizarNota(
  rows: TimelineRow[],
  note: NoteView,
): TimelineRow[] {
  return rows.map((r) => {
    if (r.kind === "note" && r.id === note.noteId)
      return { ...filaDeNota(note), occurredAt: r.occurredAt };
    if (
      r.kind === "message" &&
      note.messageId &&
      r.payload.messageId === note.messageId
    ) {
      return {
        ...r,
        payload: {
          ...r.payload,
          notes: (r.payload.notes ?? []).map((n) =>
            n.noteId === note.noteId ? note : n,
          ),
        },
      };
    }
    return r;
  });
}

/** ¿Puede este operador elegir? Hace falta Editor, que no esté respondida, y no ser el asistente. */
export function puedeElegir(
  note: NoteView,
  me: number | null,
  canEdit: boolean,
): boolean {
  return (
    !!note.choices &&
    !note.choices.answer &&
    canEdit &&
    me !== note.authorUserId
  );
}
